import { useState, useEffect } from 'react'
import PasswordCheckList from 'react-password-checklist'

// styles and images
import '../pages/login/Login.css'
import '../pages/signup/SignUp.css'
import togglePwOn from '../assets/pw_vis_on.svg'
import togglePwOff from '../assets/pw_vis_off.svg'


export default function SetPassword({setPassword, setPasswordValid, clearPassword}) {
  const [first, setFirst] = useState('')
  const [second, setSecond] = useState('')
  const [pwIsValid, setPwIsValid] = useState(false)
  const [pwIcon, setPwIcon] = useState(togglePwOn)
  const [showPassword, setShowPassword] = useState(false)

  const togglePassword = () => {
    if (!showPassword) {
      setShowPassword(true)
      setPwIcon(togglePwOff)
    } else {
      setShowPassword(false)
      setPwIcon(togglePwOn)
    }
  }

  useEffect(() => {
    setPasswordValid(pwIsValid)
    setPassword(first)
  }, [pwIsValid, first, setPassword, setPasswordValid])

  useEffect(() => {
    if (clearPassword) {
      setFirst('')
      setSecond('')
    }
  }, [clearPassword])

  return (
    <>
      <div className="form-outline mb-1">
        <label className="form-label">Password</label>
        <div className='pw-container'>
          <input 
              type={!showPassword ? 'password' : 'text'}
              className='form-control form-control-lg'
              required
              onChange={(e) => setFirst(e.target.value)}
              value={first}
            />
          <img src={pwIcon}  onClick={togglePassword} alt='show-pw'/>
        </div>
      </div>
      <div className="form-outline mb-4">
        <label className="form-label">Password Verification</label>
        <div className='pw-container'>
          <input 
              type={!showPassword ? 'password' : 'text'}
              className='form-control form-control-lg'
              required
              onChange={(e) => setSecond(e.target.value)}
              value={second}
            />
          <img src={pwIcon}  onClick={togglePassword} alt='show-pw'/>
        </div>
      </div>
      {first !== '' && <PasswordCheckList 
        rules={["minLength", "specialChar", "number", "capital", "match"]}
        minLength={10}
        value={first}
        valueAgain={second}
        onChange={(isValid) => setPwIsValid(isValid)}
      />}
    </>
  )
}
